export const API_URL = process.env.REACT_APP_API_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const WALLET_URL = process.env.REACT_APP_WALLET_URL;
export const SDK_URL = process.env.REACT_APP_SDK_URL;
export const SDK_APP_KEY = process.env.REACT_APP_SDK_APP_KEY;
export const EVEREST_SDK_ENV = process.env.REACT_APP_EVEREST_SDK_ENV;